<template>
    <v-card class="pa-2 pb-3">
        <v-card-title class="headline px-3 pb-2"
            >Update Match Details
            {{
                ["STUDENT", "STUDENT TO DOE"].includes(autoMatch.type)
                    ? " - Student"
                    : ""
            }}</v-card-title
        >

        <div v-if="!showConfirmView">
            <v-card style="background-color: #5cb860" class="mt-2 mx-3">
                <div
                    class="headline font-weight-regular text-danger mb-4 text-xs-center"
                    v-if="!selected.length"
                >
                    Please select non verified matches
                </div>

                <v-layout row v-if="selected.length">
                    <div
                        class="pa-3 pt-4 mt-1 display-1 font-weight-light"
                        style="width: 27%; color: #fff"
                    >
                        Default Values
                    </div>
                    <v-spacer></v-spacer>
                    <v-card-actions
                        class="pb-3 my-2 mx-3"
                        v-bind:style="
                            autoMatch.type == 'FAMILY'
                                ? 'width: 50%'
                                : 'width: 35%'
                        "
                        style="background-color: #fff; border-radius: 3px;"
                    >
                        <v-layout row>
                            <v-select
                                style="width: 25%;"
                                class="mr-3 ml-4"
                                :items="matchTypes"
                                v-if="autoMatch.type == 'FAMILY'"
                                label="Match Type"
                                v-model="matchType"
                                @change="updateMatchType"
                                clearable
                                hide-details
                            ></v-select>
                            <!-- <v-select
                                style="width: 25%; max-width: 350px;"
                                class="mr-3 ml-4"
                                :items="['Pending', 'Verified', 'Not Matched']"
                                label="Status"
                                v-model="status"
                                @change="updateStatus"
                                clearable
                                hide-details
                            ></v-select> -->
                        </v-layout>
                    </v-card-actions>
                </v-layout>
            </v-card>
            <v-divider></v-divider>
            <v-card-text class="pa-2 mt-3 scroll mx-2" style="height: 500px;">
                <div v-for="(person, index) in selected">
                    <v-layout row class="mb-2 mt-0">
                        <div
                            class="mr-3"
                            v-bind:style="
                                autoMatch.type == 'FAMILY'
                                    ? 'width: 50%'
                                    : 'width: 60%'
                            "
                        >
                            <v-layout row>
                                <div class="font-weight-bold">
                                    {{
                                        person.first +
                                            " " +
                                            person.last +
                                            " (" +
                                            getGander(person) +
                                            ")"
                                    }}
                                </div>
                                <div class="font-weight-regular pr-1 pl-1">
                                    - DOB:
                                </div>
                                <div class="font-weight-light">
                                    {{ person.dob | date }}
                                </div>
                            </v-layout>
                            <v-layout row
                                ><!-- <div class="font-weight-regular pr-1">
                                    Address:
                                </div> -->
                                <div class="font-weight-light pr-2">
                                    {{ getAddress(person) }}
                                </div></v-layout
                            >
                            <v-layout row style="color: #00bcd4"
                                ><div class="font-weight-bold pr-1">
                                    {{
                                        autoMatch.type == "STUDENT TO DOE"
                                            ? "DOE:"
                                            : "ANSL:"
                                    }}
                                </div>
                                <div
                                    class=""
                                    v-if="autoMatch.type != 'STUDENT TO DOE'"
                                >
                                    {{ person.anslName }}
                                </div>
                                <div
                                    class="font-weight-light pl-1"
                                    v-if="autoMatch.type != 'STUDENT TO DOE'"
                                >
                                    {{ " - " + person.anslAddress }}
                                </div>
                                <div
                                    class=""
                                    v-if="autoMatch.type == 'STUDENT TO DOE'"
                                >
                                    {{ getDoeInfo(person) }}
                                </div>
                            </v-layout>
                        </div>
                        <v-select
                            style="width: 25%;"
                            v-if="autoMatch.type == 'FAMILY'"
                            class="mx-2 pt-4"
                            :items="matchTypes"
                            label="Match Type"
                            v-model="person.matchType"
                            clearable
                            ref="matchType"
                            @change="matchTypeChanged($event, person)"
                        ></v-select>
                        <!-- <v-select
                            style="width: 25%;"
                            class="mx-2 pt-4"
                            :items="['Pending', 'Verified', 'Not Matched']"
                            label="Status"
                            v-model="person.status"
                            clearable
                            ref="status"
                        ></v-select> --></v-layout
                    ><v-divider
                        class="mt-0 mb-2 pb-1"
                        v-if="index + 1 < selected.length"
                        :key="index"
                    ></v-divider>
                </div>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn dark color="default" @click="closeDialog()"
                    >Cancel</v-btn
                >
                <v-btn
                    :disabled="disableContinue()"
                    :loading="processing"
                    color="success"
                    @click="continueToConfirm()"
                >
                    Continue
                </v-btn>
            </v-card-actions>
        </div>

        <div v-else>
            <div
                class="headline font-weight-regular text-warning mb-4 text-xs-center"
            >
                Please confirm the details below
            </div>
            <v-card-text class="pa-2 mt-3 scroll" style="height: 500px;">
                <div height="50" v-for="(person, index) in getListToSubmit()">
                    <v-layout row class="font-weight-regular">
                        <div
                            v-bind:style="
                                autoMatch.type == 'FAMILY'
                                    ? 'width: 50%'
                                    : 'width: 60%'
                            "
                            class="mr-3"
                        >
                            <v-layout row>
                                <div class="font-weight-bold">
                                    {{ person.first + " " + person.last }}
                                </div>
                                <div class="font-weight-regular pr-1 pl-1">
                                    - DOB:
                                </div>
                                <div
                                    class="font-weight-light"
                                    v-if="
                                        ['STUDENT', 'STUDENT TO DOE'].includes(
                                            autoMatch.type,
                                        )
                                    "
                                >
                                    {{ person.dob | date }}
                                </div>
                            </v-layout>
                            <v-layout row
                                ><!-- <div class="font-weight-regular pr-1">
                                    Address:
                                </div> -->
                                <div class="font-weight-light pr-2">
                                    {{ getAddress(person) }}
                                </div>
                                <!-- <div class="font-weight-regular pr-1">
                                    City:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ person.city }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Zip:
                                </div>
                                <div class="font-weight-light ">
                                    {{ person.zip }}
                                </div> --></v-layout
                            >
                            <v-layout row style="color: #00bcd4"
                                ><div class="font-weight-bold pr-1">
                                    {{
                                        autoMatch.type == "STUDENT TO DOE"
                                            ? "DOE:"
                                            : "ANSL:"
                                    }}
                                </div>
                                <div
                                    class=""
                                    v-if="autoMatch.type != 'STUDENT TO DOE'"
                                >
                                    {{ person.anslName }}
                                </div>
                                <div
                                    class="font-weight-light pl-1"
                                    v-if="autoMatch.type != 'STUDENT TO DOE'"
                                >
                                    {{ " - " + person.anslAddress }}
                                </div>
                                <div
                                    class=""
                                    v-if="autoMatch.type == 'STUDENT TO DOE'"
                                >
                                    {{ getDoeInfo(person) }}
                                </div>
                            </v-layout>
                        </div>
                        <div
                            style="width: 25%; text-align: right;"
                            class="mx-3 text-xs-center pt-4"
                        >
                            {{ person.matchType }}
                        </div>
                        <div
                            style="width: 20%;"
                            class="mx-3 text-xs-center pt-4"
                        >
                            {{ person.status }}
                        </div>
                    </v-layout>
                    <v-divider
                        class="mt-2 mb-2 pb-1"
                        v-if="index + 1 < getListToSubmit().length"
                        :key="index"
                    ></v-divider>
                </div>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn dark color="default" @click="closeDialog()"
                    >Cancel</v-btn
                >
                <v-btn dark color="default" @click="showConfirmView = false"
                    >Back</v-btn
                >
                <v-btn :loading="processing" color="success" @click="save()">
                    Save
                </v-btn>
            </v-card-actions>
        </div>
    </v-card>
</template>
<script>
import moment from "moment";
import { toISOLocal, formatCurrency } from "../../utils/helpers.js";

export default {
    props: {
        selected: Array,
        reloadGrid: Function,
        closeUpdateDialog: Function,
        autoMatch: Object,
        doeData: Array,
    },
    components: {},
    data() {
        return {
            processing: false,
            showConfirmView: false,
            status: "",
            matchType: "",

            matchTypes: ["Husband", "Wife", "Daughter", "Son", "Not Matched"],

            required: [(v) => !!v || "Required"],
        };
    },
    async created() {},
    watch: {},
    computed: {},
    methods: {
        closeDialog() {
            this.matchType = "";
            this.status = "";
            this.showConfirmView = false;
            this.processing = false;

            //statuses: ["Pending", "Verified"],

            this.closeUpdateDialog();
        },
        updateMatchType(value) {
            this.selected.forEach((person) => {
                person.matchType = value;

                this.matchTypeChanged(value, person);
            });
        },
        // updateStatus(value) {
        //     this.selected.forEach((person) => (person.status = value));
        // },
        matchTypeChanged(value, person) {
            if (!value) {
                person.status = "Pending";

                return;
            }

            if (value == "Not Matched") {
                person.status = value;
            } else {
                person.status = "Verified";
            }
        },
        getGander(person) {
            if (["STUDENT", "STUDENT TO DOE"].includes(this.autoMatch.type)) {
                return person.gander;
            }

            return person.s == "M"
                ? "Male"
                : person.s == "F"
                ? "Female"
                : "Undefined";
        },
        getAddress(person) {
            if (["STUDENT", "STUDENT TO DOE"].includes(this.autoMatch.type)) {
                return person.address1 + " " + person.city + " " + person.zip;
            }

            return (
                person.house +
                " " +
                person.street +
                " " +
                person.apt +
                " " +
                person.city +
                " " +
                person.zip
            );
        },
        getDoeInfo(student) {
            const doe = this.doeData.find((d) => d.reG_ID == student.doeID);

            if (!doe) return;

            return (
                doe.first +
                " " +
                doe.last +
                " (" +
                doe.dob +
                ") | " +
                doe.house +
                " " +
                doe.street
            );
        },
        validate() {
            // const statusValidation = this.$refs.status
            //     .map((a) => a.validate(true))
            //     .every(Boolean);

            if (["STUDENT", "STUDENT TO DOE"].includes(this.autoMatch.type))
                return;
            //return [statusValidation].every(Boolean);

            const matchTypeValidation = this.$refs.matchType
                .map((a) => a.validate(true))
                .every(Boolean);

            return [matchTypeValidation].every(Boolean);
        },
        disableContinue() {
            if (!this.selected.length) return;

            return ["STUDENT", "STUDENT TO DOE"].includes(this.autoMatch.type)
                ? !this.selected.some((s) => s.status)
                : !this.selected.some((s) => s.matchType) ||
                      !this.selected.some((s) => s.status);
        },
        getListToSubmit() {
            return ["STUDENT", "STUDENT TO DOE"].includes(this.autoMatch.type)
                ? this.selected.filter((s) => s.status)
                : this.selected.filter((s) => s.status && s.matchType);
        },
        continueToConfirm() {
            if (!this.validate()) return;

            this.showConfirmView = true;
        },
        async save() {
            this.processing = true;

            const matches = this.getListToSubmit().map((person) => {
                return {
                    status: person.status,
                    matchType: person.matchType,
                    personID: person.personID,
                    id: person.id,
                    studentID: person.studentID,
                    doeID: person.doeID,
                };
            });
            try {
                await this.$http.post("api/voting/UpdateMatchStatus", {
                    user: this.$store.state.authentication.user,
                    matches: matches,
                });

                this.processing = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.closeDialog();
                this.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.scroll {
    overflow-y: auto;
}
</style>
